export const menuStyles = {
  trigger: {
    background: "none",
    border: "none",
    fontSize: 14,
    fontWeight: 500,
    cursor: "pointer",
    padding: "6px 8px",
    display: "flex",
    alignItems: "center",
    gap: 4,
    color: "#111827",
  },
  caret: {
    fontSize: 12,
    opacity: 0.7,
  },
  popover: {
    position: "absolute",
    top: "calc(100% + 6px)",
    left: 0,
    minWidth: 220,
    background: "#ffffff",
    border: "1px solid #e5e7eb",
    borderRadius: 8,
    boxShadow: "0 10px 20px rgba(0,0,0,0.08)",
    padding: "6px 0",
    zIndex: 1000,
  },
  item: {
    width: "100%",
    background: "none",
    border: "none",
    textAlign: "left",
    padding: "8px 14px",
    fontSize: 13,
    cursor: "pointer",
    color: "#111827",
  },
};
